import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  InputGroup,
  InputRightAddon,
  RichTextEditor,
  useTheme,
} from '@wegroup/design-system';

// Components
import { FieldError } from 'react-hook-form';

interface Props {
  value: string;
  onChange: (value: string) => void;
  onBlurUpdate?: (value: string) => void;
  error?: FieldError;
  symbol?: string;
  isDisabled?: boolean;
  prefilled?: boolean;
}

const RichTextInput: React.FC<
  React.ComponentProps<typeof RichTextEditor> & Props
> = ({ prefilled, error, symbol, isDisabled, onBlurUpdate, ...props }) => {
  const { space } = useTheme();

  return (
    <FormControl isInvalid={!!error} isDisabled={isDisabled}>
      <InputGroup variant={prefilled ? 'flowsPrefilled' : 'flows'}>
        <RichTextEditor
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          defaultValue={props.value}
          style={{ width: '100%', minHeight: space[32] }}
          isDisabled={isDisabled}
          onBlurUpdate={onBlurUpdate}
          {...props}
        />
        {symbol && <InputRightAddon>{symbol}</InputRightAddon>}
      </InputGroup>
      {error?.message && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export default RichTextInput;
